export default __webpack_public_path__ + "static/media/Bianca-Giaever.b9f114d1.jpg";